<!-- 图文分离组件 -->
<template>
  <div
    class="advance-imgTxt"
    :style="{backgroundImage: `url(${$attrs.backgroundImage})`}"
  >
    <div
      class="content"
      :style="{'--maxWidth': $attrs.maxWidth}"
    >
      <!-- 主标题 -->
      <div
        class="mobile-main-title"
        v-if="mainTitle.show"
        :style="transfCss.mainTitle"
      >
        <TextEdit
          change-key="mainTitle"
          :text.sync="mainTitle.desc"
          :mode="textEdit"
          :sendData="mainTitle"
          v-on="$listeners"
        />
      </div>
      <!-- 副标题 -->
      <div
        class="mobile-sub-title"
        v-if="subTitle && subTitle.show"
        :style="transfCss.subTitle"
      >
        <TextEdit
          change-key="subTitle"
          :text.sync="subTitle.desc"
          :mode="textEdit"
          :sendData="subTitle"
          v-on="$listeners"
        />
      </div>
      <!-- 滑块 -->
      <swiper
        ref="mySwiper"
        :class="!isMobile() && 'swiper-no-swiping'"
        :options="swiperOptions"
        :style="{ padding: transfCss.padding }"
      >
        <swiper-slide
          v-for="(item, index) in $attrs.imgTxtList"
          class="swiper-slider"
          :class="[option.slidesPerView === 'auto' ? 'swiper-slider-auto' : '']"
          :key="index"
        >
          <div
            :class="[
              $attrs.layout === 'up-down' ? 'top-img-slider' : 'left-img-slider',
              $attrs.border && $attrs.border.shadow ? 'img-shadow' : ''
            ]"
            :style="{
              ...$attrs.border,
              '--b_color': item.hover && item.hover.color || ($attrs.border && $attrs.border.borderColor),
              '--b_bg': item.hover && `url(${item.hover.backgroundImage})`,
              ...transfCss.sliderStyle,
              background: item.backgroundImage ? `no-repeat center bottom/100% 100% url(${item.backgroundImage})` : '',
              backgroundColor: item.backgroundColor,
              cursor: item.link ? 'pointer' : 'auto'
            }"
            @click.prevent="openUrl(item.link)"
          >
            <!-- 内容块icon -->
            <div
              v-if="item.icons.show"
              class="img-container"
              :style="{textAlign: item.icons.textAlign}"
              @click.prevent="handleClickItem(index, 5, $event)"
            >
              <img
                :src="item.url || item.icons.url"
                :style="transfCssUtil(item.icons)"
              />
            </div>
            <div class="text">
              <!-- 内容主标题 -->
              <div
                v-if="item.mainTitle.show"
                :style="transfCssUtil(item.mainTitle)"
                class="main-title"
                @click.prevent="handleClickItem(index, 1, $event)"
              >
                <TextEdit
                  change-key="imgTxtList"
                  :text.sync="item.mainTitle.desc"
                  :mode="textEdit"
                  :sendData="$attrs.imgTxtList"
                  v-on="$listeners"
                />
                <!-- {{ item.mainTitle.desc }} -->
              </div>
              <!-- 内容标签 -->
              <div
                class="tags"
                v-if="item.tags && item.tags.list.length"
                :style="transfCssUtil(item.tags.css)"
              >
                <div
                  class="tag-item"
                  v-for="(tag, t_index) of item.tags.list"
                  :key="t_index"
                  @click.prevent.stop="mode ? openUrl(tag.url) : handleClickItem(index, 6, $event)"
                  :style="transfCssUtil(tag.tagCss)"
                >
                  <span :style="tag.fontCss">{{ tag.label }}</span>
                </div>
              </div>
              <!-- 内容副标题 -->
              <div
                v-if="item.subTitle.show"
                :style="transfCssUtil(item.subTitle)"
                :class="item.subTitle?.tip ? 'sub-title sub-title-ellipse' : 'sub-title'"
                @click.prevent="handleClickItem(index, 2, $event)"
              >
                <el-tooltip
                  placement="top"
                  v-if="item.subTitle.tip"
                >
                  <div
                    slot="content"
                    style="max-width: 250px; line-height: 20px;"
                  >{{ item.subTitle.desc }}</div>
                  <TextEdit
                    change-key="imgTxtList"
                    :text.sync="item.subTitle.desc"
                    :mode="textEdit"
                    :sendData="$attrs.imgTxtList"
                    v-on="$listeners"
                  />
                </el-tooltip>
                <TextEdit
                  v-else
                  change-key="imgTxtList"
                  :text.sync="item.subTitle.desc"
                  :mode="textEdit"
                  :sendData="$attrs.imgTxtList"
                  v-on="$listeners"
                />
              </div>
              <!-- 任务列表 -->
              <div
                class="tasks"
                v-if="item.tasks"
                :style="transfCssUtil(item.tasks.css)"
                :class="[item.tasks.divis ? 'divis' : '']"
              >
                <div
                  class="task-item"
                  v-for="(task, t_index) of item.tasks.list"
                  :key="t_index"
                  :style="{
                    ...transfCssUtil(task.taskCss),
                    cursor: item.link ? 'pointer' : ''
                  }"
                  @click.prevent="mode ? openUrl(btn.link) : handleClickItem(index, 8, $event)"
                >
                  <!-- 任务列表类型 -->
                  <span
                    class="order disorder"
                    v-if="item.tasks.taskType === 'disorder'"
                  ></span>
                  <span
                    class="order"
                    v-else-if="item.tasks.taskType === 'order'"
                  >{{ t_index + 1 }}</span>
                  <span :style="task.fontCss">
                    <TextEdit
                      change-key="imgTxtList"
                      :text.sync="task.label"
                      :mode="textEdit"
                      :sendData="$attrs.imgTxtList"
                      v-on="$listeners"
                    />
                  </span>
                </div>
              </div>
              <!-- 内容按钮 -->
              <div
                class="btns"
                v-if="item.btns.list && item.btns.list.length"
                :style="transfCssUtil(item.btns.css)"
              >
                <div
                  class="btn-item"
                  v-for="(btn, b_index) of item.btns.list"
                  :key="b_index"
                  @click.prevent.stop="mode ? openUrl(btn.url) : handleClickItem(index, 3, $event)"
                  :style="transfCssUtil(btn.btnCss)"
                >
                  <span :style="btn.fontCss">{{ btn.label }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 滑块箭头 -->
          <img
            v-if="arrow.show && $attrs.imgTxtList.length !== (index + 1)"
            class="item-arrow"
            :src="arrow.url ? arrow.url : arrowImgUrl"
            :style="{
              ...transfCss.arrow,
              right: `-${arrow.width}`
            }"
          />
        </swiper-slide>
        <div
          class="swiper-button-prev swiper-button swiper-button-black"
          slot="button-prev"
        ></div>
        <div
          class="swiper-button-next swiper-button swiper-button-black"
          slot="button-next"
        ></div>
      </swiper>
    </div>
  </div>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import merge from 'lodash/merge'
import { transfCssUtil, isMobile } from '../../utils/index'
import mixin from '../../utils/mixin'
import TextEdit from '../common/TextEdit.vue'
export default {
  props: ['option'],
  mixins: [mixin],
  data () {
    return {
      swiperOptions: {},
      isNoSwipper: true,
      transfCssUtil,
      isMobile,
      arrowImgUrl: require('../../image/arrow.png')
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    transfCss () {
      const { mainTitle, subTitle, padding, sliderStyle, arrow } = this.$attrs
      return this.transfCssUtil({
        mainTitle,
        subTitle,
        padding,
        sliderStyle,
        arrow
      })
    },
    mainTitle () {
      return this.$attrs.mainTitle
    },
    subTitle () {
      return this.$attrs.subTitle
    },
    arrow () {
      return this.$attrs.arrow || {}
    }
  },
  created () {
    this.initOptions()
  },
  methods: {
    initOptions () {
      const option = this.option
      if (!option.autoplay.is) {
        option.autoplay = false
      }
      this.swiperOptions = merge({
        direction: 'horizontal',
        autoplayDisableOnInteraction: false,
        observer: true,
        observeParents: true,
        noSwiping: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: option.openNavigation ? 'my-button-disabled' : 'my-button-hidden'
        },
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
          480: {
            slidesPerView: 1,
            spaceBetween: 10,
          }
        }
      }, option)
    }
  },
  watch: {
    option (val) {
      this.$nextTick(() => {
        if (this.swiper) {
          this.swiper.params = merge(this.swiper.params, val)
          this.swiper.navigation.$prevEl.css('display', !val.openNavigation ? 'none' : 'block')
          this.swiper.navigation.$nextEl.css('display', !val.openNavigation ? 'none' : 'block')
          this.swiper.update()
        }
      })
    },
    'option.autoplay.is': {
      handler (val) {
        if (val) {
          this.swiper.autoplay.start()
        } else {
          this.swiper.autoplay.stop()
        }
      },
      immeidate: true,
      deep: true
    }
  },
  components: {
    swiper,
    swiperSlide,
    TextEdit
  }
}
</script>
<style lang="stylus" scoped>
.advance-imgTxt
  background-repeat no-repeat
  background-size cover
  .content
    max-width var(--maxWidth, 1200px)
    margin 0 auto
  .swiper-slider
    box-sizing border-box
    position relative
  .swiper-slider-auto
    width auto !important
  .swiper-button
    width 40px
    height 40px
    background-color rgba(255, 255, 255, 0.9)
    background-size 15px 15px
    border-radius 50%
    box-shadow 0px 4px 15px 0px rgba(14, 66, 210, 0.2)
  .my-button-disabled
    cursor not-allowed
    opacity 0.2
  .my-button-hidden
    display none
  .top-img-slider, .left-img-slider
    box-sizing border-box
    overflow hidden
    &:hover
      border-color var(--b_color) !important
      background-image var(--b_bg, none)
      background-position 50%
      background-repeat no-repeat
      background-size cover
  .top-img-slider
    display flex
    flex-direction column
    align-items center
    .text
      width 100%
      display flex
      flex-direction column
      align-items center
      .sub-title
        line-height 26px
  .left-img-slider
    display flex
    align-items center
    .img-container
      flex 1
    .text
      .sub-title
        line-height 26px
  .main-title, .sub-title
    width 100%
    box-sizing border-box
    cursor text
  // .sub-title
  // display: -webkit-box
  // -webkit-box-orient: vertical
  // -webkit-line-clamp: 3
  // overflow: hidden
  // text-overflow: ellipsis
  .sub-title-ellipse
    display -webkit-box
    -webkit-box-orient vertical
    -webkit-line-clamp 3
    overflow hidden
    text-overflow ellipsis
  .img-container
    width 100%
    overflow hidden
  .btns, .tags, .tasks
    width 100%
    .btn-item, .tag-item
      display inline-block
  .tooltip-content
    max-width 200px
  .item-arrow
    position absolute
    top 50%
    right 0
    transform translateY(-50%)
  .img-shadow
    box-shadow 0px 2px 10px 0px rgba(148, 191, 255, 0.1)
  .task-item
    .order
      display inline-block
      width 7px
      height 7px
      color #0095FF
      margin-right 10px
      font-weight 600
    .disorder
      border-radius 50%
      background #0095ff
      vertical-align middle
  .divis
    border-top 1px solid #EFF4FA
</style>
<style lang="stylus" scoped>
@media screen and (max-width 1200px)
  .item-arrow, .swiper-button
    display none
</style>

